import { render, staticRenderFns } from "./BadgeNotification.vue?vue&type=template&id=4a6bfbe0"
import script from "./BadgeNotification.vue?vue&type=script&lang=js"
export * from "./BadgeNotification.vue?vue&type=script&lang=js"
import style0 from "./BadgeNotification.vue?vue&type=style&index=0&id=4a6bfbe0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports